import { uniq } from "lodash";
import {
  RefundRequestStatus,
  RefundRequestComponentType,
  ChecklistItem,
  RefundRequestComponent,
  ChecklistItemType,
  ChecklistItemUpdateType,
  RefundRequestStatusFilter,
  checklistItemTypeToLabel,
  checklistItemTypeToChecklistItemUpdateType,
  RefundRequest,
} from "../common/types";
import { toSydneyDate } from "../common/utils";

export const formatCurrency = (currency: number, inCents: boolean = true) => {
  if (inCents) {
    currency = currency * 0.01;
  }

  return `$${currency.toFixed(2)}`;
};

export const formatDateTime = (date: string | Date) => {
  const momentDate = toSydneyDate(date);
  if (momentDate.isValid()) {
    return momentDate.format("YYYY-MM-DD HH:mm");
  } else {
    return "";
  }
};

export const summarizeChecklist = (list: ChecklistItem[]) => {
  const total = list.length;
  const completed = list.filter((l: ChecklistItem) => {
    return l.checkedAt;
  }).length;

  return `${completed}/${total}`;
};

export const calcRequestTotal = (components: RefundRequestComponent[]) => {
  let total = 0;
  if (components) {
    components.forEach((c: RefundRequestComponent) => {
      total += c.amountInCents;
    });
  }

  return formatCurrency(total);
};

export const formatRefundRequestStatus: (status: RefundRequestStatusFilter) => string = status => {
  switch (status) {
    case RefundRequestStatus.ChecklistComplete:
      return "Checklist Complete";
    case RefundRequestStatus.FullyRefunded:
      return "Fully Refunded";
    case RefundRequestStatus.PartiallyRefunded:
      return "Partially Refunded";
    case RefundRequestStatus.AwaitingChecklistCompletion:
      return "Waiting";
    case RefundRequestStatus.AwaitingManualChecklistItems:
      return "CS Review";
    default:
      return status;
  }
};

export const getChecklistTypeLabel = (
  type: ChecklistItemType
): { label: string; updateType: ChecklistItemUpdateType } => {
  const label = checklistItemTypeToLabel[type] || type;
  const updateType = checklistItemTypeToChecklistItemUpdateType[type] || "manual";
  return { label, updateType };
};

export const getUpdateTypeTitle = (updateType: ChecklistItemUpdateType): string => {
  switch (updateType) {
    case "manual":
      return "This checklist item must be ticked manually";
    case "automatic":
      return "This checklist item will be ticked automatically by the system";
    default:
      return "";
  }
};

export const getComponentTypeLabel = (type: RefundRequestComponentType): string => {
  switch (type) {
    case RefundRequestComponentType.MagentoCash:
      return "Magento Cash";
    case RefundRequestComponentType.MagentoStoreCredit:
      return "Magento Store Credit";
    case RefundRequestComponentType.MagentoStoreCreditBonus:
      return "Magento Store Credit Bonus";
    case RefundRequestComponentType.PayPal:
      return "PayPal";
    default:
      return type;
  }
};

export const refundType = (request: RefundRequest) => {
  const componentTypes: RefundRequestComponentType[] = request.components.map(component => component.type);
  const refundTypes: ("cash" | "credit")[] = componentTypes.map(type => (type.includes("Credit") ? "credit" : "cash"));
  return uniq(refundTypes)
    .sort()
    .join("+");
};
